module.exports = __webpack_public_path__ + "img/next.db831207.png";